module.exports = __webpack_public_path__ + "img/reserve_rule.f1027365.png";